import { t } from '@lingui/macro'

import { ErrorLayout } from '@/modules/shared/components/error-layout/ErrorLayout'

const SynopsNoConnectionPage = () => {
  // Interaction Methods
  // ------------------------------------------------------------------------- /
  function refreshPage() {
    window.location.reload()
  }

  return (
    <ErrorLayout
      title={t({
        id: 'globals.synops-error.title',
        message: 'Technische problemen',
      })}
      message={t({
        id: 'globals.synops-error.text',
        message: 'We ondervinden technische problemen, probeer het later opnieuw.',
      })}
      cta={{
        label: t({
          id: 'globals.connection-error.cta',
          message: 'Laad de pagina opnieuw',
        }),
        onClick: refreshPage,
      }}
    />
  )
}

export { SynopsNoConnectionPage }
